import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const AppPage = () => {

  useEffect(() => {

    if (document) {
      let items = document.querySelectorAll("#dynamicStyle");
      for ( let i = 0; i < items.length; i++){
          document.head.removeChild(items[i]);
      }
      var link = document.createElement("link");
      link.id = "dynamicStyle";
      link.rel = "stylesheet";
      link.type = "text/css"; 
      link.href = "/app.css";
      
      document.head.appendChild(link);
    }

    return () => {
      let items = document.querySelectorAll("#dynamicStyle");
      for ( let i = 0; i < items.length; i++){
          document.head.removeChild(items[i]);
      }
    }
  }, []);

  return (
    <div>
      THIS IS APP~~~
      <br />
      <br />
      <Link to="/web">WEB으로 가기</Link>
    </div>
  )
}

export default AppPage;